import React,{useState,useEffect} from 'react';
import {Figure} from "react-bootstrap";
import '../../src/assets/css/introanimation.css';

function IntroAnimation(props){
    const [visible,setVisibility] = useState("hidden")
    
    useEffect(()=>{
        // Set overflow hidden when component mounts
        const originalOverflow = document.body.style.overflowY;
        document.body.style.overflowY = "hidden";
        
        const timer = setTimeout(function() {
            setVisibility("scroll");
            document.body.style.overflowY = originalOverflow || "";
        }, 4000);
        
        // Cleanup function to restore overflow when component unmounts
        return () => {
            clearTimeout(timer);
            document.body.style.overflowY = originalOverflow || "";
        };
    }, [])
    
    return(
       <>
        {visible == "hidden" ?
    <div className="intro">
    <Figure>
        <Figure.Image src={props.imgsrc}/>
        <Figure.Caption><img src={props.splashlogo}/></Figure.Caption>
    </Figure>
    </div>
:<></>}
    </>
    )
    }

export default IntroAnimation;